module.exports = __webpack_public_path__ + "img/battery.50138b2b.svg";